module.exports = __webpack_public_path__ + "img/meetings-parasole.4bc4471.jpg";